import React from 'react';
import { useStoreContext } from '../../Contexts/StoreContext';
import CardStoreList from './CardStoreList';
import { formatCurrentAddress } from '../../Utils/Formatters';
import { TbMapPinQuestion, TbMapSearch, TbPencil } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import { ORDER_TYPE_DELIVERY } from '../../Utils/Constants/Service';

interface MultipleStoresFoundProps {
    nextOrderType: any;
    stores: any;
    onHandleClick: CallableFunction,
    onCancel: CallableFunction,
}

const MultipleStoresFound = ({nextOrderType, onHandleClick, onCancel, stores }: MultipleStoresFoundProps) => {

    const { t } = useTranslation();
    const { nextCurrentAddress } = useStoreContext();

    return (
        <div className="flex flex-col gap-4 pt-4 h-full">

            <div className='flex flex-col gap-4 text-center bg-white p-4 px-6'>

                {nextOrderType === ORDER_TYPE_DELIVERY 
                    ?   <TbMapPinQuestion size={45} className='mx-auto text-shopfood-title' />
                    :   <TbMapSearch size={45} className='mx-auto text-shopfood-title' />
                }

                <div className='grid place-items-center gap-1'>
                    <h2 className='text-xl font-bold leading-none text-custom-primary'>
                        {nextOrderType === ORDER_TYPE_DELIVERY 
                            ?   t('start.multiple_stores_found.delivery.title') 
                            :   t('start.multiple_stores_found.title') 
                        }
                    </h2>
                    <span className='text-base font-semibold text-shopfood-title'>
                        {nextOrderType === ORDER_TYPE_DELIVERY 
                            ?   t('start.multiple_stores_found.delivery.subtitle') 
                            :   t('start.multiple_stores_found.subtitle') 
                        }
                    </span>
                </div>

                { (nextCurrentAddress && nextOrderType === ORDER_TYPE_DELIVERY) &&
                    <div onClick={() => onCancel()} className="grid gap-1.5 leading-none mt-1 text-sm px-6 cursor-pointer">
                        <div className="flex items-center gap-0.5 justify-center font-semibold">{t('start.multiple_stores_found.edit_label')} <TbPencil /></div>
                        <span className="text-gray-400">{formatCurrentAddress(nextCurrentAddress)}</span>
                    </div>
                }
            </div>

            <div className="flex flex-col gap-4 h-full bg-gray-50 border-t border-gray-100 p-4">
                {stores.map((store: any) =>
                    <CardStoreList orderType={nextOrderType} onCardClick={() => onHandleClick(store)} store={store} key={`${store.id}`} />
                )}
            </div>
        </div>
    )
}

export default MultipleStoresFound;